var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListOProgram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.667 2.333A4.667 4.667 0 0 1 51.333 7v42a4.667 4.667 0 0 1-4.666 4.667H9.333A4.667 4.667 0 0 1 4.667 49V7a4.667 4.667 0 0 1 4.666-4.667h37.334zm0 4.667H9.333v42h37.334V7zm-8 30.333a1 1 0 0 1 1 1V41a1 1 0 0 1-1 1H17.333a1 1 0 0 1-1-1v-2.667a1 1 0 0 1 1-1h21.334zm0-11.666a1 1 0 0 1 1 1v2.666a1 1 0 0 1-1 1H17.333a1 1 0 0 1-1-1v-2.666a1 1 0 0 1 1-1h21.334zm0-11.667a1 1 0 0 1 1 1v2.667a1 1 0 0 1-1 1H17.333a1 1 0 0 1-1-1V15a1 1 0 0 1 1-1h21.334z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOProgram);
export default __webpack_public_path__ + "static/media/list-o-program.25e2a37a.svg";
export { ForwardRef as ReactComponent };